import { Copy } from 'lucide-react'
import toast from 'react-hot-toast'

import { Button } from '@/ui-components/Button'
import { Heading } from '@/ui-components/Heading'

export type AccountDetailsData = {
  accountName: string
  accountNumber: string
  bankCode: string
  branchCode: string
  swiftCode: string
  bankName: string
  bankAddress: string
  bankLocation: string
}

const AccountDetails = ({ data }: { data: AccountDetailsData }) => {
  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text)
    toast.success('Copied to clipboard!')
  }

  return (
    <div className="space-y-6 border rounded-lg border-gray-50 dark:border-gray-800">
      <Heading
        className="p-4 sm:p-6 mb-0"
        level={4}
      >
        Account Details
      </Heading>

      <hr className="mb-0 border-gray-50 dark:border-gray-800" />

      <div className="p-4 sm:p-6">
        <div className="flex items-end justify-between gap-2">
          <div className="flex flex-col md:flex-row md:gap-x-1 pb-2.5 sm:pb-1.5">
            <Heading
              level={5}
              className="md:flex"
            >
              Account name<span className="hidden md:block">:</span>
            </Heading>
            <span>{data.accountName}</span>
          </div>
          <Button
            plain
            onClick={() => copyToClipboard(data.accountName)}
          >
            <Copy data-slot="icon" />
          </Button>
        </div>

        <div className="flex items-end justify-between gap-2">
          <div className="flex flex-col md:flex-row md:gap-x-1 py-1.5">
            <Heading
              level={5}
              className="md:flex"
            >
              Bank account number<span className="hidden md:block">:</span>
            </Heading>
            <span>{data.accountNumber}</span>
          </div>
          <Button
            plain
            onClick={() => copyToClipboard(data.accountNumber)}
          >
            <Copy data-slot="icon" />
          </Button>
        </div>

        <div className="flex items-end justify-between gap-2">
          <div className="flex flex-col md:flex-row md:gap-x-1 py-1.5">
            <Heading
              level={5}
              className="md:flex"
            >
              Bank code<span className="hidden md:block">:</span>
            </Heading>
            <span>{data.bankCode}</span>
          </div>
          <Button
            plain
            onClick={() => copyToClipboard(data.bankCode)}
          >
            <Copy data-slot="icon" />
          </Button>
        </div>

        <div className="flex items-end justify-between gap-2">
          <div className="flex flex-col md:flex-row py-1.5">
            <Heading
              level={5}
              className="md:flex"
            >
              Branch code<span className="hidden md:block">:</span>
            </Heading>
            <span>{data.branchCode}</span>
          </div>
          <Button
            plain
            onClick={() => copyToClipboard(data.branchCode)}
          >
            <Copy data-slot="icon" />
          </Button>
        </div>

        <div className="flex items-end justify-between gap-2">
          <div className="flex flex-col md:flex-row md:gap-x-1 py-1.5">
            <Heading
              level={5}
              className="md:flex"
            >
              SWIFT code<span className="hidden md:block">:</span>
            </Heading>
            <span>{data.swiftCode}</span>
          </div>
          <Button
            plain
            onClick={() => copyToClipboard(data.swiftCode)}
          >
            <Copy data-slot="icon" />
          </Button>
        </div>

        <div className="flex items-end justify-between gap-2">
          <div className="flex flex-col md:flex-row md:gap-x-1 py-1.5">
            <Heading
              level={5}
              className="md:flex"
            >
              Account location<span className="hidden md:block">:</span>
            </Heading>
            <span>{data.bankLocation}</span>
          </div>
          <Button
            plain
            onClick={() => copyToClipboard(data.bankLocation)}
          >
            <Copy data-slot="icon" />
          </Button>
        </div>

        <div className="flex items-end justify-between gap-2">
          <div className="flex flex-col md:flex-row md:gap-x-1 py-1.5">
            <Heading
              level={5}
              className="md:flex"
            >
              Bank name<span className="hidden md:block">:</span>
            </Heading>
            <span>{data.bankName}</span>
          </div>
          <Button
            plain
            onClick={() => copyToClipboard(data.bankName)}
          >
            <Copy data-slot="icon" />
          </Button>
        </div>

        <div className="flex items-end justify-between gap-2">
          <div className="flex flex-col md:flex-row md:gap-x-1 py-1.5">
            <Heading
              level={5}
              className="md:flex"
            >
              Bank address<span className="hidden md:block">:</span>
            </Heading>
            <span>{data.bankAddress}</span>
          </div>
          <Button
            plain
            onClick={() => copyToClipboard(data.bankAddress)}
          >
            <Copy data-slot="icon" />
          </Button>
        </div>
      </div>
    </div>
  )
}

export default AccountDetails
